/* eslint-disable no-unused-vars */
// Pub
import { gptPubIds } from "@/service/wd_pubsub_config.js";
import { publish } from "@/service/wd_pubsub.js";
import { i18n } from "@i18n";
import store from "@/store";

import {
  isValidColor,
  isValidTransparency,
  isValidWeight,
  isValidMargin,
} from "@/pptjs/utils/validation";

// api
import { generateIconUrl, insertImageByUrl } from "../util/gpt_addin_utils.js";

// Office
const Office = window.Office;
var PowerPoint = window.PowerPoint;

export async function process_icon_layout() {
  PowerPoint = window.PowerPoint
  publish(
    gptPubIds.pubId_Local_Gpt_ProcessingText,
    i18n.t("ppt_addin.process.text_ppt_generating_content_parsing")
  );
  try {
    await PowerPoint.run(async function (context) {
      let selectedSlides = context.presentation.getSelectedSlides();
      selectedSlides.load("items");
      await context.sync();
      if (selectedSlides.items.length === 0) {
        publish(
          gptPubIds.pubId_Local_Addin_SystemLog,
          i18n.t("ppt_addin.message.text_message_not_select_slide")
        );
        publish(gptPubIds.pubId_Local_Gpt_Processing_Success, "");
        return null;
      }
  
      let selectedSlide = selectedSlides.items[0];
      selectedSlide.load("shapes");
      await context.sync();
      let shapeCollection = selectedSlide.shapes;
      shapeCollection.load("items");
      await context.sync();
      let shapes = shapeCollection.items;
  
      let slideContentText = "";
      let shapeTitle = null;
      for (let i = 0; i < shapes.length; i++) {
        // 一个Shape的JSON数据
        let shape = shapes[i];
        shape.load("$all");
        await context.sync();
  
        if (shape.type == "GeometricShape") {
          // shape text frame
          let textFrame = shape.textFrame;
          textFrame.load("hasText");
          await context.sync();
          if (textFrame.hasText) {
            // text range
            textFrame.load("textRange");
            await context.sync();
            let textRange = textFrame.textRange;
            textRange.load("$all");
            await context.sync();
            if (
              shape.name.startsWith("Text") ||
              shape.name.startsWith("Content")
            ) {
              slideContentText = textRange.text;
              // 删除Shape
              shape.delete();
              await context.sync();
            } else if (shape.name.startsWith("Title")) {
              shapeTitle = shape;
            }
          }
        } else if (shape.type === "Image") {
          shape.delete();
          await context.sync();
        }
      }
  
      // 如果content有内容，解析成数组
      if (slideContentText.length == 0) {
        publish(
          gptPubIds.pubId_Local_Addin_SystemLog,
          i18n.t("ppt_addin.message.text_message_nocontent_process")
        );
        publish(gptPubIds.pubId_Local_Gpt_Processing_Success, "");
        return null;
      }
  
      // 按照换行来解析内容，并根据数量计算布局的数据
      let textArray = slideContentText.split("\r");
      let shapesData = null;
      if (textArray.length == 4) {
        shapesData = store.get("gpt/iconLayout_4");
      } else if (textArray.length == 3) {
        shapesData = store.get("gpt/iconLayout_3");
      }
      // 插入标题
      await _changeTitleFrame(context, shapeTitle, shapesData.title);
      // 插入图标和文字组合
      for (let i = 0; i < textArray.length; i++) {
        let imageText = textArray[i];
        // 生成图标url
        publish(
          gptPubIds.pubId_Local_Gpt_ProcessingText,
          i18n.t("ppt_addin.process.text_ppt_generating_icon")
        );
        // let iconUrl = "https://f7.baidu.com/it/u=2757647852,732655506&fm=222&app=106&size=f360,240&n=0&f=JPEG?s=C4DA7F8D087A07905D8C6DB303001003&sec=1683997200&t=6c57ec515528e3b894c24d831c8d43bf";
        let iconUrl = await generateIconUrl(imageText);
        // 插入图标
        let shapeData = shapesData.icon[i];
        let imageOptions = {
          coercionType: Office.CoercionType.Image,
          imageLeft: shapeData.image.left,
          imageTop: shapeData.image.top,
          imageWidth: shapeData.image.width,
          imageHeight: shapeData.image.height,
        };
        await insertImageByUrl(iconUrl, imageOptions, 2);
        // 插入TextBox
        await _insertTextBox(imageText, shapeData);
      }
  
      // 生成完毕，显示个数
      let processtingText = i18n.t(
        "ppt_addin.process.text_ppt_generating_icon_success"
      );
      let count = textArray ? textArray.length : 0;
      processtingText = processtingText.replace(/\{0\}/g, count + "");
      publish(gptPubIds.pubId_Local_Addin_SystemLog, processtingText);
      publish(gptPubIds.pubId_Local_Gpt_Processing_Success, "");
    });
  } catch (error) {
    console.log("process_icon_layout");
    publish(gptPubIds.pubId_Local_PPT_init_error, error);
  }
}

async function _changeTitleFrame(context, shapeTitle, shapeData) {
  shapeTitle.load("$all");
  await context.sync();
  shapeTitle.left = shapeData.left;
  shapeTitle.top = shapeData.top;
  shapeTitle.width = shapeData.width;
  shapeTitle.height = shapeData.height;
  await context.sync();
}

async function _insertTextShape(text, shapeData) {
  PowerPoint = window.PowerPoint
  try {
    await PowerPoint.run(async function (context) {
      let selectedSlides = context.presentation.getSelectedSlides();
      selectedSlides.load("items");
      await context.sync();
      let selectedSlide = selectedSlides.items[0];
      selectedSlide.load("shapes");
      await context.sync();
      let shapeCollection = selectedSlide.shapes;
      // 插入一个形状
      let geometricShape = shapeCollection.addGeometricShape("Rectangle", {
        left: shapeData.left,
        top: shapeData.top,
        height: shapeData.height,
        width: shapeData.width,
      });
      await context.sync();
      await _updateShapeText(context, geometricShape, shapeData, text);
    });
  } catch (error) {
    console.log("_insertTextShape");
    publish(gptPubIds.pubId_Local_PPT_init_error, error);
  }
}

async function _updateShapeText(context, shape, shapeData, text) {
  shape.load({ expand: "fill, lineFormat, textFrame" });
  await context.sync();
  // line format
  if (shapeData.lineFormat != undefined) {
    let lineFormat = shape.lineFormat;
    lineFormat.load("color, visible, transparency, dashStyle, style, weight");
    if (isValidColor(shapeData.lineFormat.color)) {
      lineFormat.color = shapeData.lineFormat.color;
    }
    lineFormat.visible = shapeData.lineFormat.visible;
    if (isValidTransparency(shapeData.lineFormat.transparency)) {
      lineFormat.transparency = shapeData.lineFormat.transparency;
    }
    lineFormat.dashStyle = shapeData.lineFormat.dashStyle;
    lineFormat.style = shapeData.lineFormat.style;
    if (isValidWeight(shapeData.lineFormat.weight)) {
      lineFormat.weight = shapeData.lineFormat.weight;
    }
    await context.sync();
  }

  // fill
  if (shapeData.fill != undefined) {
    let fill = shape.fill;
    fill.load("foregroundColor, transparency");
    await context.sync();
    // 可以更新的是下面两项，type不能修改
    if (shapeData.fill.type === "NoFill") {
      fill.clear();
    } else {
      if (isValidColor(shapeData.fill.foregroundColor)) {
        fill.foregroundColor = shapeData.fill.foregroundColor;
      }
      if (isValidTransparency(shapeData.fill.transparency)) {
        fill.transparency = shapeData.fill.transparency;
      }
    }
    await context.sync();
  }
  // text frame
  if (shapeData.textFrame !== undefined) {
    let textFrame = shape.textFrame;
    textFrame.load({
      select:
        "topMargin, bottomMargin, leftMargin, rightMargin, wordWrap, verticalAlignment",
      expand: "textRange",
    });
    await context.sync();
    if (isValidMargin(shapeData.textFrame.topMargin)) {
      textFrame.topMargin = shapeData.textFrame.topMargin;
    }
    if (isValidMargin(shapeData.textFrame.bottomMargin)) {
      textFrame.bottomMargin = shapeData.textFrame.bottomMargin;
    }
    if (isValidMargin(shapeData.textFrame.leftMargin)) {
      textFrame.leftMargin = shapeData.textFrame.leftMargin;
    }
    if (isValidMargin(shapeData.textFrame.rightMargin)) {
      textFrame.rightMargin = shapeData.textFrame.rightMargin;
    }
    textFrame.verticalAlignment = shapeData.textFrame.verticalAlignment;
    textFrame.wordWrap = shapeData.textFrame.wordWrap;
    await context.sync();

    if (shapeData.textFrame !== undefined) {
      // text range
      let textRange = textFrame.textRange;
      textRange.load({
        select: "text, length, start",
        expand: "font, paragraphFormat",
      });
      await context.sync();
      textRange.text = shapeData.textFrame.textRange.text;
      await context.sync();

      // font
      let font = textRange.font;
      font.load("bold, color, italic, name, size, underline");
      await context.sync();
      font.color = shapeData.textFrame.textRange.font.color;
      font.bold = shapeData.textFrame.textRange.font.bold;
      font.italic = shapeData.textFrame.textRange.font.italic;
      font.name = shapeData.textFrame.textRange.font.name;
      font.size = shapeData.textFrame.textRange.font.size;
      font.underline = shapeData.textFrame.textRange.font.underline;
      await context.sync();
    }
  }
}

async function _insertTextBox(text, shapeData) {
  PowerPoint = window.PowerPoint
  try {
    await PowerPoint.run(async function (context) {
      let selectedSlides = context.presentation.getSelectedSlides();
      selectedSlides.load("items");
      await context.sync();
      let selectedSlide = selectedSlides.items[0];
      selectedSlide.load("shapes");
      await context.sync();
      let shapeCollection = selectedSlide.shapes;
  
      // insert text box
      let options = {
        left: shapeData.textBox.left,
        top: shapeData.textBox.top,
        width: shapeData.textBox.width,
        height: shapeData.textBox.height,
      };
      let textBox = shapeCollection.addTextBox(text, options);
      await context.sync();
      textBox.load("textFrame");
      await context.sync();
      // shape text frame
      let textFrame = textBox.textFrame;
      // text range
      textFrame.load("textRange");
      await context.sync();
      let textRange = textFrame.textRange;
      textRange.load({
        select: "text, length, start",
        expand: "font, paragraphFormat",
      });
      await context.sync();
      // font
      let font = textRange.font;
      font.load("bold, color, italic, name, size, underline");
      await context.sync();
      font.color = shapeData.textBox.textFrame.textRange.font.color;
      font.bold = shapeData.textBox.textFrame.textRange.font.bold;
      font.italic = shapeData.textBox.textFrame.textRange.font.italic;
      font.name = shapeData.textBox.textFrame.textRange.font.name;
      font.size = shapeData.textBox.textFrame.textRange.font.size;
      font.underline = shapeData.textBox.textFrame.textRange.font.underline;
      await context.sync();
      // textFrame.topMargin = shapeData.textBox.textFrame.topMargin;
      // textFrame.leftMargin = shapeData.textBox.textFrame.leftMargin;
      // textFrame.rightMargin = shapeData.textBox.textFrame.rightMargin;
      // textFrame.bottomMargin = shapeData.textBox.textFrame.bottomMargin;
      // textFrame.verticalAlignment = shapeData.textBox.textFrame.verticalAlignment;
      // textFrame.wordWrap = shapeData.textBox.textFrame.wordWrap;
      // await context.sync();
    });
  } catch (error) {
    console.log("_insertTextBox");
    publish(gptPubIds.pubId_Local_PPT_init_error, error);
  }
}
